// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3TRAB","requiredAsterisk":"Info_requiredAsterisk__3KFuq"};